import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";

/**
 * Confirms cancelling one company in a running batch. Its task is stopped and it gets
 * no sheet; the other companies carry on.
 *
 * @param {{ companyName: string | null, onClose: () => void, onConfirm: () => void }} props
 */
function CancelCompanyDialog({ companyName, onClose, onConfirm }) {
  return (
    <Dialog open={Boolean(companyName)} onClose={onClose}>
      <DialogTitle>Cancel {companyName}?</DialogTitle>
      <DialogContent>
        <Divider sx={{ mb: 2 }} />
        <Typography variant="body1">
          Its auto4client task is stopped and it will not get a sheet — data already written
          to the database stays, but is incomplete. The other companies in this batch carry on.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Keep running</Button>
        <Button color="error" onClick={onConfirm}>
          Cancel company
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CancelCompanyDialog;
